module.exports = __webpack_public_path__ + "files/a9d0677616aa9a050d5575e9151b736b.png";